export default __webpack_public_path__ + "static/media/communities.7489a0d6.jsonc";